// @NOTE: assumes jQuery is included by WP
const $ = jQuery

import Swiper from 'swiper/bundle';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; 
import MotionPathPlugin from "gsap/MotionPathPlugin"; 
import DrawSVGPlugin from "gsap/DrawSVGPlugin"; 

// don't forget to register plugins
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, DrawSVGPlugin);  

class general {
  constructor () {
    this.$window = $(window)
    this.$playButton           = $('.js-play-button')
    this.$closeModalButton     = $('.js-close-modal')
    this.$player               = null 
    this.$body                 = $('body')
    this.$iframe               = $('body .video-modal iframe')
    this.modalIsOpen           = false
    this.openVideoModal()  
    this.closeVideoModal()
    this.svgAnimations() 


    

    // //scroll svg

//     var svgEl = document.getElementById("svgEl");
// var length = svgEl.getTotalLength();

// svgEl.style.strokeDasharray = length;

// svgEl.style.strokeDashoffset = length;

// window.addEventListener("scroll", myFunction);

// function myFunction() {
//   var scrollpercent = (document.body.scrollTop + document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

//   var draw = length * scrollpercent;
//   svgEl.style.strokeDashoffset = length - draw;
// }
    // // Get the id of the <path> element and the length of <path>
    // var myline = document.getElementById("myline");
    // var length = myline.getTotalLength();
    // var circle = document.getElementById("circle");
    // // The start position of the drawing
    // myline.style.strokeDasharray = length;

    // // Hide the triangle by offsetting dash. Remove this line to show the triangle before scroll draw
    // myline.style.strokeDashoffset = length;

    // // Find scroll percentage on scroll (using cross-browser properties), and offset dash same amount as percentage scrolled
    // window.addEventListener("scroll", myFunction);

    // function myFunction() {
    //   // What % down is it?
    //   var scrollpercent = (document.body.scrollTop + document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
    //   // Length to offset the dashes
    //   var draw = length * scrollpercent;

    //   // Reverse the drawing (when scrolling upwards)
    //   myline.style.strokeDashoffset = length - draw;

    //   //get point at length
    //   var endPoint = myline.getPointAtLength(draw);
    //   circle.setAttribute("cx", endPoint.x);
    //   circle.setAttribute("cy", endPoint.y);

    // }


    //touch enabled
    function is_touch_enabled() {
    return ( 'ontouchstart' in window ) || 
           ( navigator.maxTouchPoints > 0 ) || 
           ( navigator.msMaxTouchPoints > 0 );
    }

    if( is_touch_enabled() ) {
        $('html').addClass('is-touch');
        $('.portfolio-box').click(function (e){
      if($(this).hasClass('binder')){
        e.preventDefault();
        $('.portfolio-box').addClass('binder');
        $(this).removeClass('binder');
      }
      else{
        $(this).addClass('binder');
      }
      });
    }
    else {
    }

    $.fn.isOnScreen = function() {
      var win = $(window);
      var viewport = {
          top: win.scrollTop(),
          left: win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();
      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  };

    $('.parallax').each(function() {
     var $bgobj = $(this);              
      $(window).scroll(function() {
        if ($bgobj.isOnScreen()) {              
          var yPos = -($(window).scrollTop() / $bgobj.data('speed')); 
          var coords = '50% '+ yPos + 'px';
          $bgobj.css({ backgroundPosition: coords });
        }
      });

    });

    //homepage carousel
		if ($('.section-hero .carousel-container .swiper-slide').length > 1) {
			var swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        allowTouchMove: true,
        grabCursor: true,
        slidersPerView: 1,
        updateOnWindowResize: true,
        autoplayDisableOnInteraction: false,
	      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
	      autoplay: {
	        delay: 5000,
	        disableOnInteraction: false,
	      }
	    });
		}

    //subpage carousel
    if ($('.section-subpage-hero .carousel-container .swiper-slide').length > 1) {
      var swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        grabCursor: true,
        slidersPerView: 1,
        updateOnWindowResize: true,
        autoplayDisableOnInteraction: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        }
      });
    }

  }

  openVideoModal () {
		this.$playButton.on('click', (event) => { 
      const videoIframe = $(event.currentTarget).attr('data-iframe');
      $('#iframe-video-holder').append(videoIframe);
			$('.video-modal').addClass('show-modal')
			this.$body.addClass('overflow-hidden')
			this.modalIsOpen = true 
		}) 
	}

  GetVimeoIDbyUrl(url) {
    var id = false;
    var request = new XMLHttpRequest();
    request.open('GET', 'https://vimeo.com/api/oembed.json?url='+url , false);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
      var response = JSON.parse(request.responseText);
        if(response.video_id) {
          id = response.video_id;
        }
      }
    };
    request.send();
    return id;
  }

  closeVideoModal () {
		this.$closeModalButton.on('click', (event) => {  
			event.preventDefault();
			$(event.currentTarget).parents('.video-modal').removeClass('show-modal') 
			this.$body.removeClass('overflow-hidden')   
			$('#iframe-video-holder iframe').remove();
      this.stopIframeVideo()
      this.modalIsOpen = false
		})

		this.$body.on('click', (event) => {
			if (!this.modalIsOpen) {
				return
			}
			
			if (!$(event.target).closest('.modal-inner, .play-overlay').length) {
				$('body').find('.video-modal').removeClass('show-modal')  
				$('body').removeClass('overflow-hidden') 
				$('#iframe-video-holder iframe').remove();
        this.stopIframeVideo()
			}
		})
	}

  stopIframeVideo() {
    this.$iframe.each((index, element) => {
	    $(element).attr('src', $(element).attr('src'));
	    return false;
		});
  }

  onWindowResize () {
    const parallaxWindowHeight = $('.parallax-container').innerHeight()
    console.log(parallaxWindowHeight)
    $('.svg-container svg').css('height', parallaxWindowHeight)
  }

  

  svgAnimations () {
    

    const banneAnimation = gsap.timeline ({
        // scrollTrigger: {
        //     trigger: '.carousel-container',
        //     scrub: false,
        //     start: "top top",
        //     end: "bottom center"
        // }
    })

    banneAnimation.addLabel("startanimation")
    .fromTo(".line1", {autoAlpha:0}, {autoAlpha:1})
    .fromTo(".line2", {autoAlpha:0}, {autoAlpha:1}, 0)
    .from(".line1", {drawSVG:0, duration:4}, 0)
    .fromTo(".line2",  {drawSVG:"100% 100%"}, {drawSVG:"0% 100% ", duration:4},0) 


    const scrollAnim1 = gsap.timeline ({
        scrollTrigger: {
            trigger: '.feature-block-1',
            scrub: true,
            start: "top center",
            end: "bottom center"
        }
    })
    scrollAnim1.addLabel("startanimation1")
    .from(".line3", {drawSVG:0, duration:2}) 

    const scrollAnim2 = gsap.timeline ({
        scrollTrigger: {
            trigger: '.feature-block-2',
            scrub: true,
            start: "top center",
            end: "bottom center"
        }
    })

    scrollAnim2.addLabel("startanimation2")
    .from(".line4", {drawSVG:0, duration:2})  
    .from(".line5", {drawSVG:0, duration:2}, 0)

    const scrollAnim3 = gsap.timeline ({
        scrollTrigger: {
            trigger: '.feature-block-3',
            scrub: true,
            start: "top 20%",
            end: "bottom center"
        }
    })
    scrollAnim3.addLabel("startanimation3") 
    .fromTo(".line6",  {drawSVG:"100% 100%"}, {drawSVG:"0% 100% "})
    .fromTo(".line7",  {drawSVG:"100% 100%"}, {drawSVG:"0% 100% "})
    
    const scrollAnim4 = gsap.timeline ({
        scrollTrigger: {
            trigger: '.feature-block-4',
            scrub: true,
            start: "top center",
            end: "bottom center", 
        }
    })

    scrollAnim4.addLabel("startanimation4")
    .from(".line8", {drawSVG:0, duration:2})  
    .from(".line9", {drawSVG:0, duration:2}, 0) 

    const footerAnim = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
          trigger: ".section-availibility-home",
          scrub: true,
          start: "top center",
          end: "bottom 80%", 
         //scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar 
        }
    }); 

    // add animations and labels to the timeline
    footerAnim.addLabel("start")
    .from(".section-availibility-home line10", {drawSVG:0, duration:2})  
    .from(".section-availibility-home line11", {drawSVG:0, duration:2}, 0)
    .from(".section-availibility-home line12", {drawSVG:0, duration:2}, 0)

    


    
  }

}

export default general


// WEBPACK FOOTER //
// ./src/js/custom/general/general.js